// extracted by mini-css-extract-plugin
module.exports = {"magazineInsert":"MagazineInsert_magazineInsert__9dmF3"};